import {findHandlingWorkModels, findWork, FindWorkResponseData} from "../../../utils/awsAmplifyUtil";
import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";
import {WORK_ATTRS} from "../../../constants/work";
import {FindModelResponse} from "../../../types/pj1dbApiHandling";

export interface UseHandlingWorkModel {
  onChange: (newData: FindModelResponse|null, newStatus: Status) => void;
  instanceId: string;
  enableAutoFetch?: boolean;
  initialStatus?: Status;
}

export function useHandlingWorkModel(params: UseHandlingWorkModel) {
  const result = useFetchAllQuery({
    queryFn: () => findHandlingWorkModels({
        instanceId: params.instanceId,
      }),
    needToFetchMore: () => false,
    enableAutoFetch: params.enableAutoFetch,
  });
  const helperResult = useFetchAllQueryHelper({
    onChange: params.onChange,
    data: result.data.find(() => true) ?? null,
    status: result.status,
    initialStatus: params.initialStatus,
  })

  return {
    ...result,
    ...helperResult,
  };
}
